
import { Component, Prop, Vue, Mixins, Watch, Emit } from 'vue-property-decorator';
import multiselect from 'vue-multiselect';
// import InfoIcon from '../../core/components/InfoIcon.vue'

@Component({
    components: {
        multiselect,
        // InfoIcon
    }
})
export default class Combobox extends Vue {
    @Prop() label: string;
    @Prop() selectorValue: string;
    @Prop() placeholder: string;
    @Prop() selectorDescription: string;
    @Prop() customValue: any;
    @Prop() customLabel: any;
    @Prop({default(){return[]}}) options: Array<object>;
    @Prop() resetValue: boolean;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: false }) showActiveDot: boolean;
    @Prop() disabled: boolean;
    @Prop({ default: '' }) noOptionText: string;
    @Prop({ default: 'No hay elementos que coincidan con la búsqueda' }) noResultsText: string;
    @Prop({ default: '' }) classWrapperCombobox: string;
    @Prop({ default: 'auto' }) comboboxItemHeight: string;
    @Prop({ default: '' }) classLabel: string;
    @Prop({ default: 'Elegir' }) selectLabel: string;
    @Prop({ default: false }) showError: boolean;
    @Prop({ default: true }) showCloseBtn: boolean;
    value: any = null;

    getOptionText(option){
        if(this.customLabel){
            return this.customLabel(option)
        }
        return option[this.selectorDescription]
    }


    @Emit()
    searchChange(){}

    @Watch('customValue', { deep: true })
    watchCustomValue(value) {
        this.value = value;
    }


    mounted() {
        if (this.customValue !== null) {
            this.value = this.customValue;
        }
    }

    @Watch('resetValue')
    removeValue(value) {
        if (value) {
            this.value = null;
            this.$emit('update-reset-value', false);
        }
    }

    selectOption(selectedOption, id) {
        this.$emit('selected-option', selectedOption);
    }

    clearSelector() {
        this.value = null;
        this.$emit('selected-option', null);
    }
}
